import _regeneratorRuntime from 'babel-runtime/regenerator';

var _this = this;

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

import { getApiEndpoint } from '../helpers';
export var BASE_URL = getApiEndpoint(process.env.REACT_APP_RM_ENV);
export var callAPI = function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_ref2) {
    var method = _ref2.method,
        endpoint = _ref2.endpoint,
        token = _ref2.token,
        body = _ref2.body;
    var targetUrl, headers, response, errorResponse, error, json;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            targetUrl = '' + BASE_URL + endpoint;
            headers = token ? new Headers({
              'Cache-Control': 'no-cache',
              'Content-Type': 'application/json',
              token: token
            }) : new Headers({
              'Cache-Control': 'no-cache',
              'Content-Type': 'application/json'
            });
            _context.next = 5;
            return fetch(targetUrl, {
              method: method,
              headers: headers,
              body: JSON.stringify(body)
            });

          case 5:
            response = _context.sent;

            if (response.ok) {
              _context.next = 13;
              break;
            }

            _context.next = 9;
            return response.json();

          case 9:
            errorResponse = _context.sent;
            error = Error('Invalid API Response');
            error.msg = errorResponse.errors ? errorResponse.errors[0].message : errorResponse.statusMessage ? errorResponse.statusMessage : 'API Error';
            throw error;

          case 13:
            _context.next = 15;
            return response.json();

          case 15:
            json = _context.sent;
            return _context.abrupt('return', json);

          case 19:
            _context.prev = 19;
            _context.t0 = _context['catch'](0);
            throw _context.t0;

          case 22:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 19]]);
  }));

  return function callAPI(_x) {
    return _ref.apply(this, arguments);
  };
}();